import React from 'react'
import SidebarItem from './sidebar-item'
import withPresentation from '../../../with-presentation'

const SidebarItemContainer = ({
  presentation,
  presentationState,
  ...props
}) => {
  return <SidebarItem showLabel={presentationState.sidebarOpened} {...props} />
}

export default withPresentation(SidebarItemContainer)
